// extracted by mini-css-extract-plugin
export default {"wrapper":"GenericService_wrapper__N6ryj","head":"GenericService_head__nGGFu","dropdownGroup":"GenericService_dropdownGroup__Bsik2"};